import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import {
  AiFillGithub,
  AiOutlineMail,
} from "react-icons/ai";
import { SiVelog } from "react-icons/si";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center justify-content-center">
            <Col md={6} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> KIM MINGYEONG(김민경)</strong>
              </h1>

              <div style={{ padding: "24px 0 0", textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={4} className="home-hero-image" style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "270px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />

      <Container>
        <Row style={{ paddingTop: "34px", paddingBottom: "56px" }}>
          <Col md={12} className="home-about-social">
            <h1>Find Me On</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/kmg22"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://velog.io/@kmg22/about"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <SiVelog />
                </a>
              </li>
            </ul>
            <p style={{ marginTop: "12px", fontSize: "0.78em", color: "#c770f0" }}>
              <AiOutlineMail style={{ marginRight: "6px", verticalAlign: "middle", fontSize: "1em" }} />
              ssukmg22@gmail.com
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
